import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, qs } from '../lib/api';
import type { MachineRow } from '../lib/types';
import { MachineForm } from '../components/forms';
import { Button, Input, Loading, Modal, PageHeader, Table } from '../components/ui';

export function MachinesPage() {
  const [q, setQ] = useState('');
  const [adding, setAdding] = useState(false);
  const navigate = useNavigate();
  const rows = useQuery({ queryKey: ['machines-list', q], queryFn: () => api.get<MachineRow[]>(`/api/machines${qs({ q })}`) });
  return (
    <>
      <PageHeader title="Machines">
        <Input placeholder="Serial, make, model, EQ #…" value={q} onChange={(e) => setQ(e.target.value)} className="w-72" />
        <Button onClick={() => setAdding(true)}>New machine</Button>
      </PageHeader>
      <div className="rounded-lg border border-slate-200 bg-white">
        {rows.isLoading ? <Loading /> : (
          <Table head={['Make / model', 'Serial', 'EQ #', 'Customer', '']} empty={rows.data?.length === 0}>
            {rows.data?.map((m) => (
              <tr key={m.id} className="hover:bg-slate-50">
                <td className="px-3 py-2"><Link className="font-medium text-blue-800 hover:underline" to={`/machines/${m.id}`}>{m.make} {m.model}</Link></td>
                <td className="px-3 py-2 font-mono">{m.serialNumber}</td>
                <td className="px-3 py-2">{m.equipmentNo}</td>
                <td className="px-3 py-2">{m.customer?.name ?? (m.isRentalFleet ? 'Rental fleet' : '—')}</td>
                <td className="px-3 py-2 text-xs text-slate-500">{m.controls}</td>
              </tr>
            ))}
          </Table>
        )}
      </div>
      {adding && (
        <Modal title="New machine" onClose={() => setAdding(false)}>
          <MachineForm onSaved={(m) => navigate(`/machines/${m.id}`)} onCancel={() => setAdding(false)} />
        </Modal>
      )}
    </>
  );
}
